import { render, staticRenderFns } from "./jjvc_store.vue?vue&type=template&id=be332f56&"
import script from "./jjvc_store.vue?vue&type=script&lang=js&"
export * from "./jjvc_store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "jjvc_store.vue"
export default component.exports